import styled from 'styled-components';

export const MobileContainer = styled.div`
  display: inline-block;
  height: 60px;
  width: 100%;
  border-bottom: 2px solid ${({ theme }) => theme.colors.disable};
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }

  .menu-bar {
    display: flex;
    justify-content: space-between;
    margin: 14px 20px;
    align-items: center;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin: 14px 74px;
    }

    & .menu-icon {
      cursor: pointer;
      font-size: 20px;
    }
  }
`;

export const SidebarContainer = styled.div<{ $Open: boolean }>`
  transition: height 0.3s cubic-bezier(0.6, -0.28, 0.735, 0.045);
  height: ${({ $Open }) => ($Open ? '470px' : '0px')};
  max-height: fit-content;
  overflow: hidden;
  z-index: 99999;
  width: 100%;
  position: absolute;
  top: 60px;
  background-color: ${({ theme }) => theme.colors.white};
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }

  .main-menu {
    margin: 20px 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      margin: 20px 74px;
    }

    & .btn {
      display: flex;
      gap: 15px;
    }
  }
`;

export const LaptopContainer = styled.div`
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  z-index: ${({ theme }) => theme.zIndices.header};
  background-color: #fff;
  display: none;
  height: 65px;
  width: 100%;
  border-bottom: 2px solid ${({ theme }) => theme.colors.disable};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: inline-block;
  }

  .main-nav {
    display: flex;
    justify-content: space-between;
    margin: 14px 100px;

    & .main-routes {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 35px;

      & .btn {
        display: flex;
        gap: 15px;
      }
    }
  }
`;
